const isNonEmptyString = (v: unknown): v is string => typeof v === 'string' && v.trim().length > 0;

export function assertNonEmptyString(value: unknown, fieldName: string): asserts value is string {
  if (!isNonEmptyString(value)) {
    throw new Error(`${fieldName} is required`);
  }
}

export function assertArray<T = unknown>(value: unknown, fieldName: string): asserts value is T[] {
  if (!Array.isArray(value)) {
    throw new Error(`${fieldName} must be an array`);
  }
}

export function normalizeLimit(limit: unknown, fallback: number, max = 1000): number {
  const n = typeof limit === 'number' && Number.isFinite(limit) ? Math.floor(limit) : fallback;
  if (n <= 0) return fallback;
  return Math.min(n, max);
}

export function normalizeOffset(offset: unknown, fallback = 0): number {
  const n = typeof offset === 'number' && Number.isFinite(offset) ? Math.floor(offset) : fallback;
  return Math.max(0, n);
}


